import { ConversationHeaderData } from '@/models/conversation';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAssistantStore = defineStore('assistantStore', () => {
  const legalAssistantSelectedText = ref<string | undefined>(undefined);
  const legalAssistantHeaderData = ref<ConversationHeaderData>({
    loading: false,
    showNewConversation: false,
    showHistory: false
  });

  function createAssistantActions() {
    function setHeaderData(data: ConversationHeaderData) {
      legalAssistantHeaderData.value = data;
    }

    function resetHeaderData() {
      const resetData = {
        loading: false,
        showNewConversation: false,
        showHistory: false
      };

      legalAssistantHeaderData.value = resetData;
    }

    function setSelectedText(text: string) {
      legalAssistantSelectedText.value = text;
    }

    function clearSelectedText() {
      legalAssistantSelectedText.value = undefined;
    }

    return {
      setHeaderData,
      resetHeaderData,
      setSelectedText,
      clearSelectedText
    };
  }

  return {
    legalAssistantSelectedText,
    legalAssistantHeaderData,
    createAssistantActions
  };
});
